import React, { Component, Fragment } from 'react';

import { Button } from 'components/button';
import { Loader } from 'components/loader';
import { Modal } from 'components/modal';
import { I18n } from 'components/translate';
import { UiService } from 'modules/ui';
import { UserManagerService } from 'modules/userManager';
import PropTypes from 'prop-types';

export default class DeleteUserModal extends Component {
  static propTypes = {
    handleSuccess: PropTypes.func,
    toggleModal: PropTypes.func,
    userId: PropTypes.string
  };

  state = {
    showLoader: false
  };

  confirmModal = async () => {
    const { handleSuccess, userId, toggleModal } = this.props;

    this.setState({ showLoader: true });

    try {
      await UserManagerService.delete(userId);
      handleSuccess && handleSuccess();
    } catch (error) {
      UiService.handleError(error);
    } finally {
      toggleModal && toggleModal();
    }
  };

  render() {
    const { toggleModal } = this.props;
    const { showLoader } = this.state;

    return (
      <Modal
        title="users_manager.users_list.delete_modal.title"
        onClose={toggleModal}
      >
        <Modal.Body>
          <p>
            <I18n label="users_manager.users_list.delete_modal.description" />
          </p>
        </Modal.Body>

        <Modal.Footer>
          {({ actions }) => (
            <Fragment>
              {showLoader ? (
                <Loader key="loader" />
              ) : (
                <Fragment>
                  <button
                    className="hot-button hot-button--primary hot-button--lg"
                    onClick={() => this.confirmModal(actions)}
                  >
                    <I18n label="general.ok" />
                  </button>
                  <Button size="large" outline onClick={actions.closeModal}>
                    <I18n label="general.cancel" />
                  </Button>
                </Fragment>
              )}
            </Fragment>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}
